import React from 'react';
import UserProfile from './user-profile';

const TopHeader: React.FC = () => {
  return (
    <div style={{
      height: '30px',
      backgroundColor: '#1a1a1a',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      padding: '0 10px',
      marginBottom: '10px',
      fontSize: '24px',
      fontWeight: 'bold',
      zIndex: 1000,
      flexShrink: 0
    }}>
      DV Securities - Liquid Products
      <UserProfile />
    </div>
  );
};

export default TopHeader;
